import { useInfiniteQuery, useQuery } from '@tanstack/react-query'

import api from 'services/api'

import { formatParams, loadingGrid } from 'utils/formatters'
import { getSocialThumbByBrowser } from 'utils/helpers'
import { getSearchVersionCookie } from 'utils/searchVersionCheck'

export const getSymptoms = async () => await api.get('/symptom/')
export const getLanguages = async () => await api.get('/get_languages/')

// TODO: Remover implementação temporária devido ao teste A/B baseado na origem da busca, quando time de produto definir - FRE-614

export const findPsychologists = async (searchParams) => {
  const searchVersion = getSearchVersionCookie()

  const isValidSearchVersion = searchVersion === 'v1' || searchVersion === 'v2'
  const endpoint = isValidSearchVersion
    ? `/${searchVersion}/professionals/search/`
    : '/v2/professionals/search/'

  const response = await api.post(endpoint, formatParams(searchParams))
  const psychologists = loadingGrid(response.data.results)

  const psychologistsWithSocialThumb = psychologists.map((p) => ({
    ...p,
    social_thumb: getSocialThumbByBrowser(p)
  }))

  return {
    ...response.data,
    results: psychologistsWithSocialThumb
  }
}

export const loadSkills = async () => await api.get('/professional_skill/')

export const useSymptoms = (options = {}) =>
  useQuery(['get-symptoms'], getSymptoms, {
    ...options,
    select: ({ data }) => data || []
  })

export const useProfessionalSkills = (options = {}) =>
  useQuery(['get-professional-skills'], loadSkills, { ...options, select: ({ data }) => data })

export const useSearchPsychologists = (params = {}, options = {}) =>
  useInfiniteQuery(['get-psychologists'], () => findPsychologists(params), {
    ...options,
    getNextPageParam: (last) => last?.next,
    getPreviousPageParam: (first) => first?.previous
  })
